import React, { useEffect, createElement } from 'react';
interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
}
export function SEO({
  title,
  description,
  keywords
}: SEOProps) {
  useEffect(() => {
    document.title = `${title} | Ambient Solutions LLC`;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = description;
      document.head.appendChild(meta);
    }
    if (keywords) {
      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', keywords);
      } else {
        const meta = document.createElement('meta');
        meta.name = 'keywords';
        meta.content = keywords;
        document.head.appendChild(meta);
      }
    }
  }, [title, description, keywords]);
  return null;
}